import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsTemperatureMetadataServices } from "../../../../APIServices/EIWRS/ShipmentManagement/eiwrsTemperatureMetadataServices";

const AddNewStudyTemperatureMetadata = ({ getEIWRSTemperatureMetadataData }) => {
  let { studyId } = useParams();
  const [temperature, setTemperature] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewEIWRSTemperatureMetadata = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.temperature = temperature;
    let data = await eiwrsTemperatureMetadataServices.addNewEIWRSTemperatureMetadata(
      userData
    );
    if (data?.statusCode === 200) {
      setTemperature("");
      getEIWRSTemperatureMetadataData()
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    setTemperature("");
  }, []);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Temperature{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setTemperature(e.target.value)}
          value={temperature}
          className="br3"
          placeholder="Enter Temperature"
          type="text"
        />
      </Form.Group>
      <div className="text-end">
        <button
          disabled={!temperature || buttonLoader}
          onClick={addNewEIWRSTemperatureMetadata}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm"/> Adding...
            </div>
          ) : (
            "Add Temperature"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddNewStudyTemperatureMetadata;
